<script setup>
import {reactive, ref} from "vue";
import {validateNumber} from "../../store/form_validate"
import {useSystem} from "../../store/system"
import {useUser} from "../../store/user"
import {ElMessage} from "element-plus";

const userStore = useUser()
const systemStore = useSystem()
//获取提现方式
systemStore.withdrawalMethodListApi()
//获取所有提现记录
userStore.withdrawLogApi('all')

const ruleFormRef = ref(null)
const ruleForm = reactive({
  amount: '',
  payment_id: '',
  wallet_address: '',
  payment_pwd: ''
})
const rules = reactive({
  amount: [
    {required: true, validator: validateNumber, message: 'Invalid number!', trigger: 'blur'},
  ],
  payment_id: [
    {required: true, message: 'Please choose payment!', trigger: 'blur'},
  ],
  wallet_address: [
    {required: true, type: 'string', message: 'Invalid address!', trigger: 'blur'},
  ],
  payment_pwd: [
    {required: true, type: 'string', message: 'Invalid password!', trigger: 'blur'},
  ]
})

const submitLoading = ref(false)
const submitForm = async (formEl) => {
  if (!formEl) return
  submitLoading.value = true
  await formEl.validate((valid, fields) => {
    if (valid) {
      if (parseFloat(ruleForm.amount) < parseFloat(currentPayment.value.min) ||
          parseFloat(ruleForm.amount) > parseFloat(currentPayment.value.max)) {
        ElMessage({
          duration: 1500,
          message: `Amount min ${parseFloat(currentPayment.value.min)} max ${currentPayment.value.max}`,
          type: 'error',
          onClose: () => {
            submitLoading.value = false
          }
        })
        return
      }
      userStore.userWithdrawApi({
        payment_id: ruleForm.payment_id,
        amount: ruleForm.amount,
        password: ruleForm.payment_pwd,
        address: ruleForm.wallet_address
      })

      formEl.resetFields()
      setTimeout(() => {
        userStore.withdrawLogApi('all')
      }, 800)
    } else {
      console.log('error submit!', fields)
    }
    submitLoading.value = false
  })
}
const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}

const currentPayment = ref(null)
const withdrawChange = (value) => {
  let payment = systemStore.getWithdrawList.find(item => item.id == value)
  currentPayment.value = payment
  ruleForm.wallet_address = payment.address
}

</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Withdraw</div>
        <div class="tw-p-4 tw-flex tw-justify-center">
          <el-form
              ref="ruleFormRef"
              style="max-width: 500px"
              :model="ruleForm"
              :rules="rules"
              label-width="auto"
              label-position="top"
              class="tw-w-full"
              size="large"
              status-icon
          >
            <el-form-item label="Withdraw Network" prop="payment_id">
              <el-select v-model="ruleForm.payment_id" placeholder="Withdraw Network" @change="withdrawChange">
                <el-option
                    class="!tw-h-[45px]"
                    v-for="(item, index) in systemStore.getWithdrawList"
                    :label="item.name"
                    :key="index"
                    :value="item.id"
                >
                  <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                    <el-avatar :size="30" :src="item.image" />
                    <div class="tw-ml-2">{{item.name}}</div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Wallet Address" prop="wallet_address">
              <el-input v-model="ruleForm.wallet_address" :readonly="true" placeholder="Please add wallet first"/>
            </el-form-item>

            <el-form-item label="Amount" prop="amount">
              <el-input type="number" v-model="ruleForm.amount" placeholder="Please enter USD">
                <template #prefix>
                  <i class="ti ti-currency-dollar tw-text-gray-500 tw-text-[18px]"></i>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item label="Payment Password" prop="payment_pwd">
              <el-input type="password" v-model="ruleForm.payment_pwd" placeholder="Please enter password"/>
              <span class="feature__text tw-text-[14px]">Default password: {{systemStore.website.default_pay_password}}</span>
            </el-form-item>

            <el-form-item>
              <div class="tw-mt-[1rem] tw-flex tw-justify-end tw-w-full tw-space-x-5">
                <el-button @click="resetForm(ruleFormRef)">Clear</el-button>
                <el-button :loading="submitLoading" type="primary" @click="submitForm(ruleFormRef)">
                  Submit
                </el-button>
              </div>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </el-col>
    <el-col :span="24" class="tw-mt-4">
      <el-pagination
          background layout="prev, pager, next"
          :page-size="parseInt(userStore.getWithdrawPage.limit)"
          :total="parseInt(userStore.getWithdrawPage.total)"
          @change="userStore.withdrawChange" />
    </el-col>

    <el-col :span="24">
      <div class="card-bg tw-mt-16">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Withdraw Log</div>
        <div class="tw-p-4">
          <el-table
              :data="userStore.getWithdrawLog"
              class="tw-w-full"
          >
            <el-table-column prop="createtime" label="Date">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.createtime)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="order_number" label="Order No">
              <template #default="{row, column, $index}">
                <div>{{row.order_number}}</div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="submit_amount" label="Submit amount">-->
<!--              <template #default="{row, column, $index}">-->
<!--                <div>$ {{parseFloat(row.submit_amount).toFixed(2)}}</div>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="amount" label="Amount">
              <template #default="{row, column, $index}">
                <div>$ {{parseFloat(row.amount).toFixed(2)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="payment_id" label="Payment">
              <template #default="{row, column, $index}">
                <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                  <el-avatar class="tw-flex-none" v-if="row.image" :size="30" :src="row.image" />
                  <div class="tw-ml-2">{{row.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="Status">
              <template #default="{row, column, $index}">
                <!--                0待审核 1通过 2拒绝-->
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-blue-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 0">Pending review</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-green-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 1">Passed</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-red-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 2">Reject</div>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :image-size="120"></el-empty>
            </template>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss">
.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}
</style>
